export default {
  stops: {
    title: 'Duraklar',
    pageTitle: 'Durak Yönetimi',

    empty: {
      title: 'Henüz durak eklenmedi.',
      description: "Yeni bir tane oluşturmaya başlamak için Yeni Durak'a tıklayın.",
      createButton: 'Yeni Durak',
    },

    actions: {
      add: 'Yeni Durak',
      edit: 'Düzenle',
      delete: 'Sil',
      cancel: 'İptal',
      save: 'Kaydet',
      close: 'Kapat',
      retry: 'Tekrar dene',
      reset: 'Sıfırla',
    },

    search: {
      placeholder: 'Durak ara…',
      noResults: 'Sonuç bulunamadı',
      loading: 'Aranıyor…',
      resultCount: '{count} sonuç bulundu',
      showing: 'İlk {count} sonuç gösteriliyor',
      showAll: 'Tümünü göster',
      showFirst: 'İlk {count} sonucu göster',
      narrowSearch: 'Diğerleri için aramayı daraltın',
    },

    filter: {
      title: 'Filtrele',
      apply: 'Filtreleri Uygula',
      clear: 'Sıfırla',
      tagsLabel: 'Aktif filtreler',
      removeTag: '{name} filtresini kaldır',
      clearAll: 'Tüm filtreleri kaldır',
      tags: {
        universal: 'Evrensel Duraklar',
        onlyAda: 'Sadece ADA',
        archived: 'Arşivlenmiş',
      },
      optionsLabel: 'Seçenekler',
      categoriesLabel: 'Durak Tipleri',
      modulesLabel: 'Modüller',
      campusesLabel: 'Kampüsler',
      universalLabel: 'Evrensel durakları dahil et',
      onDemandLabel: 'Sadece talep üzerine',
      onlyAdaLabel: 'Sadece talep üzerine ADA',
      includeArchivedLabel: 'Arşivlenmişleri dahil et',
    },

    list: {
      moduleLabel: 'Modül',
      categoryLabel: 'Kategori',
      usedForLabel: 'Kullanım',
      coverageLabel: 'Kapsama',
      campusLabel: 'Kampüs',
      addressLabel: 'Adres',
      pickup: 'Biniş',
      dropoff: 'İniş',
      pickupAndDropoff: 'Biniş & İniş',
      usedIn: '{count} rotada kullanılıyor',
      viewMore: '{count} tane daha',
      viewLess: 'Daha az göster',
      coverageRadius: '{value} {unit} yarıçap',
      coveragePolygon: 'Çokgen kapsama',
      universalBadge: 'Evrensel',
      onDemandBadge: 'Talep Üzerine',
      archivedBadge: 'Arşivlenmiş',
    },

    detail: {
      title: 'Durak detayı',
      generalSection: 'Genel',
      coverageSection: 'Kapsama',
      usageSection: 'Aşağıdaki rotalarda kullanılıyor',
      noRoutes: 'Bu durak şu anda hiçbir rotada kullanılmıyor.',
      wheelchairAccessible: 'Tekerlekli sandalye erişimli',
      moduleHeader: 'Modüller',
      pickupHeader: 'Biniş',
      dropoffHeader: 'İniş',
      coordinatesHeader: 'Koordinatlar',
      polygonAreaHeader: 'Alan',
      radiusHeader: 'Yarıçap',
      campusHeader: 'Kampüs',
      rows: {
        stopName: 'Durak Adı',
        modules: 'Modüller',
        coverage: 'Kapsama',
        category: 'Kategori',
        responsibleCampus: 'Sorumlu Kampüs',
        location: 'Konum',
        usedFor: 'Kullanım',
        wheelchair: 'Tekerlekli Sandalye Erişimi',
        currentlyUsedIn: 'Şu anda kullanıldığı yerler',
      },
      values: {
        yes: 'Evet',
        no: 'Hayır',
      },
      noLocation: 'Bu durak için konum bilgisi yok.',
    },

    edit: {
      title: 'Durağı düzenle',
      titleCreate: 'Durak ekle',
      namePlaceholder: 'Durak adı girin',
      radiusPlaceholder: 'Yarıçap',
      polygonHint: 'Harita üzerinde çokgeni düzenleyin.',
      selectCategory: 'Kategori seçin',
      selectCampus: 'Kampüs seçin',
      wheelchairToggle: 'Erişimli',
      serviceLabel: 'Hizmet',
      onlyAdaToggle: 'Sadece talep üzerine ADA',
      onlyAdaCheckbox: 'Sadece ADA',
      modulesImmutableHint: 'Modüller oluşturulduktan sonra değiştirilemez.',
      errorNameRequired: 'Durak adı zorunludur.',
      errorLocationRequired: 'Haritada bir konum seçin.',
      errorModulesRequired: 'En az bir modül seçin.',
      errorCoverageRequired: 'Bir kapsama türü seçin.',
      errorRadiusPositive: '0’dan büyük bir yarıçap girin.',
      errorPolygonInvalid: 'En az 3 köşeli bir çokgen çizin.',
      errorCampusRequired: 'Bir sorumlu kampüs seçin.',
      coverageCampusOptional: 'Kampüs durakları için isteğe bağlıdır. Kapsama seçilmezse kampüs alanı kullanılır.',
      campusLocationLocked: 'Bu bir kampüs durağı: konumu buradan değiştirilemez. Ad, sorumlu kampüs ve kapsama düzenlenebilir.',
    },

    locationUpdate: {
      title: 'Konumu güncelle',
      body: 'Durağın konumunu güncellemek ister misiniz?',
      confirm: 'Evet, güncelle',
      cancel: 'İptal',
    },

    moduleWarning: {
      title: 'Modül değişikliği onay gerektirir',
      body: 'Modüllerin değiştirilmesi bu durağı kullanan mevcut rotaları etkileyebilir. Emin misiniz?',
      confirm: 'Evet, değiştir',
      cancel: 'İptal',
    },

    deleteConfirm: {
      title: 'Durak silinsin mi?',
      body: 'Durak arşivlenecek. Bu durağı kullanan mevcut rotalar tarihsel bağlaçlarını koruyacak.',
      bodyNamed: '“{name}” durağı arşivlenecek. Bu durağı kullanan mevcut rotalar tarihsel bağlaçlarını koruyacak.',
      confirm: 'Evet, sil',
      cancel: 'İptal',
    },

    deleteBlocked: {
      title: 'Durak silinemez',
      bodyRoutes: 'Bu durak şu anda bir veya daha fazla rota tarafından kullanılıyor. Silmeden önce aşağıdaki rotalardan kaldırın.',
      bodyRoutesCount: 'Seçilen durak şu anda {count} rotada kullanılıyor.',
      bodyOnDemand: 'Seçilen durak şu anda aktif talepler için kullanılmaktadır.',
      bodyCampusActive: 'Bu durak aktif bir kampüse bağlı. Durağı silmeden önce kampüsü pasife alın.',
      viewAll: 'Tümünü gör',
      viewLess: 'Daha az göster',
    },

    errors: {
      STOP_NAME_DUPLICATE_FOR_CAMPUS: 'Durak adı sistemde bulunmaktadır.',
      STOP_PIN_OUTSIDE_POLYGON: 'Durak pini kapsama çokgeninin içinde olmalıdır.',
      STOP_RADIUS_NEGATIVE: 'Yarıçap 0’dan büyük olmalıdır.',
      STOP_POLYGON_INVALID: 'Çizilen çokgen geçersiz. En az 3 farklı köşe olmalı ve kenarlar kesişmemelidir.',
      STOP_CAMPUS_REQUIRED: 'Bu kampüs durağı için bir kampüs seçin.',
      STOP_CAMPUS_NOT_AUTHORIZED: 'Bu kampüsü atamak için yetkiniz yok.',
      CAMPUS_STOP_LOCATION_LOCKED: 'Kampüs durağının konumu buradan değiştirilemez.',
      STOP_FIELD_IMMUTABLE: 'Modüller, kategori ve talep üzerine alanı oluşturulduktan sonra değiştirilemez.',
      STOP_IN_USE_BY_ROUTES: 'Bu durak şu anda bir veya daha fazla rota tarafından kullanılıyor.',
      STOP_HAS_ACTIVE_ON_DEMAND_REQUESTS: 'Seçilen durak şu anda aktif talepler için kullanılmaktadır.',
      STOP_NOT_FOUND: 'Durak bulunamadı.',
      saveFailed: 'Durak kaydedilemedi.',
      deleteFailed: 'Durak silinemedi.',
    },

    legend: {
      title: 'Harita göstergesi',
      showAreas: 'Alanları göster',
      hideAreas: 'Alanları gizle',
      toggleAll: 'Tümünü değiştir',
      searchLocation: 'Konum ara...',
      zoomIn: 'Yakınlaştır',
      zoomOut: 'Uzaklaştır',
      // Harita yönergeleri — VSER-12779 §3.4.1 / §3.4.2, Zeplin 13–15_Stops_Add.
      radiusInstruction: 'Yeni durağı eklemek istediğiniz yere haritada tıklayın.',
      polygonFromSearchInstruction: 'Durak, adres aramanıza göre eklendi. Durak pininden başlayarak çokgenin köşelerini belirlemek için haritaya tıklayın. İsterseniz pini daha sonra çokgen içinde taşıyabilirsiniz.',
      polygonInstruction: 'Kapsama alanını tanımlayan çokgenin köşelerini ayarlamak için haritaya tıklayın. Durak pini varsayılan olarak ilk köşeye eklenecektir, ancak çokgenin içinde taşıyabilirsiniz.',
      pinOutsidePolygonWarning: 'Pin, kapsama alanının içinde olmalıdır.',
      clearArea: 'Temizle',
    },

    tabs: {
      shuttleVanpool: 'Servis/ Vanpool',
      onDemand: 'Talep Üzerine',
    },

    categories: {
      REGULAR: 'Standart',
      PARK_AND_RIDE: 'Park & Ride',
      CAMPUS_STOPS: 'Kampüs Durakları',
      BUS_STOPS: 'Otobüs Durakları',
      DEPOT: 'Garajlar',
      ON_DEMAND: 'Talep Üzerine',
      UNIVERSAL: 'Evrensel Duraklar',
    },

    modules: {
      SHUTTLE: 'Servis',
      VANPOOL: 'Vanpool',
    },

    coverage: {
      RADIUS: 'Yarıçap',
      POLYGON: 'Çokgen',
      none: '—',
    },

    routeStatus: {
      ACTIVE: 'Aktif',
      DRAFT: 'Taslak',
      PASSIVE: 'Pasif',
      ARCHIVED: 'Arşivlenmiş',
    },

    feedback: {
      loadError: 'Duraklar yüklenemedi. Lütfen tekrar deneyin.',
      detailError: 'Durak detayları yüklenemedi.',
    },
  },
};
